"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fontFamily = `
    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Thin.ttf') format('truetype');
        font-weight: 100;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-ExtraLight.ttf') format('truetype');
        font-weight: 200;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Light.ttf') format('truetype');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Medium.ttf') format('truetype');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-SemiBold.ttf') format('truetype');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-ExtraBold.ttf') format('truetype');
        font-weight: 800;
        font-style: normal;
    }

    @font-face {
        font-family: 'Outfit';
        src: url('/fonts/interalpen-tyrol/Outfit-Black.ttf') format('truetype');
        font-weight: 900;
        font-style: normal;
    }
        
    html {
        font-family: "Outfit", sans-serif;
    }
`;
exports.default = {
    fontFamily,
};
